webpackJsonp(["conditioner12"],{

/***/ "./src/js/components/filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = filter;
function filter($el, options) {
  var dropdowns = $el.querySelectorAll('select');

  dropdowns.forEach(function (element) {

    var paramsString = window.location.search;
    var searchParams = new URLSearchParams(paramsString);
    // return modified string.
    element.addEventListener('change', function (e) {

      if (searchParams.get('page')) searchParams.delete('page');

      if (element.id === 'category') {
        searchParams.set('category', element.value);
        window.location.search = searchParams.toString();
      }
      if (element.id === 'location') {
        searchParams.set('location', element.value);
        window.location.search = searchParams.toString();
      }
    });
  });

  return function () {
    dropdowns.forEach(function (element) {
      element.removeEventListener('change');
    });
  };
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner12.febc08b350e7921bf005.js